import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import moment from "moment";
import _ from "lodash"
import { Panel } from "primereact/panel"
import { Ripple } from "primereact/ripple"
import { RadioButton } from "primereact/radiobutton"
import { Tooltip } from "primereact/tooltip"

import { Button, DropDownField, TextAreaField, TextInputField } from "../../../../helpers"
import Messages from "../../../../helpers/Messages";

import BillingAddressCards from "../../../../common/BillingAddressCards"
import ShippingAddressCards from "../../../../common/ShippingAddressCards"
import DisplaySellerPOItem from "./DisplaySellerPOItem"
import PaymentTermsApprovalRemarks from "./PaymentTermsApprovalRemarks"

import { insertSellerPO } from "../../../../services/api/sellerPO"
import { raiseToast } from "../../../../services/redux/reducers/toast/toast"
import { getCompanyBillAddrsByPanCode } from "../../../../services/api/companyBillAddr";
import { vrcCheckAtSellerPOCreation } from "../../../../services/api/buyerReq";
import { getSellerDetailsBySellerReqs } from "../../../../services/api/sellerReq";

import { calculateSellerPO, getSellerPOApprovals, round } from "../../../../utils"
import { getPMCompanyConfig } from "../../../../setup/pmCompanyConfig"
import { DATE_FORMAT } from "../../../../constants";


const DisplaySellerPO = (props) => {
    const {
        allMaterialDetails,
        displaySellerPO,
        displaySellerPOItems,
        relatedSellerCompanyDetails,
        setIsPageLoading,
        allDisplaySellerPOs,
        setDisplaySellerPOs,
        HSNMasterData,
        setDisplaySellerPOItems,
        companyCreditPeriods,
        incoTerms,
        buyerShipAddrs,
        procmartShipAddrs,
        relatedPMStates,
        procmartCompanyBillAddrs,
        companyWarehouses,
        selectedReq,
        buyerQuoteItems,
        tdsSections,
        buyerPoCreatedAtDate,
        setIsLoading,
        setSellerCompanyDetails,
        sellerCompanyDetails,
        approvals,
        buyerReq,
        buyerPOItems,
        stockMaterials,
        pastSellerPOsInfo,
        nonRoutedSellerPOsInfo,
        buyerPO,
        materialMandatoryUseFromStock,
        prevSellerPOs,
        sellerBankAccounts,
        companyCertificates
    } = props

    const [visiblePaymentTermRemarks, setVisiblePaymentTermsRemarks] = useState(false)
    const [requiredApprovals, setRequiredApprovals] = useState([])
    const [panAPITriggered, setpanAPITriggered] = useState()
    const [bankAccounts, setBankAccounts] = useState([])

    const [paymentTermsRemarks, setPaymentTermsRemarks] = useState('')
    const [TDSDisplayData, setTDSDisplayData] = useState({
        tdsSectionName: '',
        tdsValue: null
    })

    const materialSpecifications = useSelector(state => state.common.materialSpecifications)
    const materialBrands = useSelector(state => state.common.materialBrands)

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const userDetails = useSelector(state => state.userDetails)
    const vendorRateContracts = useSelector(state => state.common.vendorRateContracts)

    const pmCompanyConfig = getPMCompanyConfig(displaySellerPO.pmCompanyId)

    let tdsOptions = [
        { tdsSectionId: 1, tdsSection: 'No TDS', displayTDSSection: 'No TDS | 0%', tdsValue: 0 },
        { tdsSectionId: 2, tdsSection: '194J', displayTDSSection: '194J | 10%', tdsValue: 10 },
        { tdsSectionId: 3, tdsSection: '194C', displayTDSSection: '194C | 1%', tdsValue: 1 },
        { tdsSectionId: 4, tdsSection: '194Q', displayTDSSection: '194Q | 0.1%', tdsValue: 0.1 },
        { tdsSectionId: 5, tdsSection: 'Other', displayTDSSection: 'Other', tdsValue: null },
    ]

    let gstRates = pmCompanyConfig.GSTRates
    let gstOptions = []
    gstRates.map(eachGSTRate => gstOptions.push({label: eachGSTRate.toString(), value: eachGSTRate}))

    useEffect(() =>{

        const isServiceHSNsProductsExists = displaySellerPOItems.some(eachPOItem => {
            if(eachPOItem.HSNCode.toString().slice(0, 2) === '99' && eachPOItem.HSNCode.toString().length === 6){
                return true
            }
            return false
        })

        let updatedDisplaySellerPO = displaySellerPO
        let tdsValue

        if (pmCompanyConfig.isTDSAutomated){
            let tdsSection 
            if(displaySellerPO.companyId !== displaySellerPO.pmCompanyId){
                if (isServiceHSNsProductsExists){
                    if (relatedSellerCompanyDetails.tdsSectionId === 1 || !relatedSellerCompanyDetails.tdsSectionId) {
                        return
                    } else {
                        tdsSection = tdsSections?.find(eachTDSSection => eachTDSSection.tdsSectionId === relatedSellerCompanyDetails?.tdsSectionId)
                    }
                } else if (relatedSellerCompanyDetails.tdsSection194q){
                    tdsSection = tdsSections.find(eachTDSSection => eachTDSSection.tdsSectionId === 1)
                } else {
                    tdsSection = tdsSections.find(eachTDSSection => eachTDSSection.tdsSectionId === 8)
                }
            } else {
                tdsSection = tdsSections.find(eachTDSSection => eachTDSSection.tdsSectionId === 8)
            }

            
            if (relatedSellerCompanyDetails.panCode && relatedSellerCompanyDetails.panCode[3] === "P"){
                tdsValue = tdsSection.individualTDSRate
            }else{
                tdsValue = tdsSection.othersTDSRate
            }
            updatedDisplaySellerPO = {...updatedDisplaySellerPO, tdsSectionId: tdsSection.tdsSectionId}
        }

        const relatedTdsSection = tdsSections.find(each => each.tdsSectionId === updatedDisplaySellerPO.tdsSectionId)
        if(relatedTdsSection){
            setTDSDisplayData(prevState => ({
                ...prevState,
                tdsSectionName: relatedTdsSection.tdsSectionName,
                tdsValue: tdsValue
            }))
        }

        calculateApprovals()
        
    },[displaySellerPO])

    useEffect(() => {
        const relatedSellerBankAccounts = sellerBankAccounts.filter(eachBankAccount => eachBankAccount.companyId === displaySellerPO.companyId && eachBankAccount.branchId.includes(displaySellerPO.branchId))
        if (relatedSellerBankAccounts.length) {
            if (relatedSellerBankAccounts.length === 1) {
                const updatedDisplaySellerPOs = allDisplaySellerPOs.map(eachDisplaySellerPO => {
                    if (eachDisplaySellerPO.displaySellerPOId === displaySellerPO.displaySellerPOId) {
                        return { ...eachDisplaySellerPO, prefBankAccountId: relatedSellerBankAccounts[0].bankAccId }
                    }
                    return eachDisplaySellerPO
                })
                setDisplaySellerPOs(updatedDisplaySellerPOs)
            }

            setBankAccounts([...relatedSellerBankAccounts])
        }
    }, [sellerBankAccounts])

    const calculateApprovals = () => {
        const calculatedResult = calculateSellerPO(displaySellerPO, displaySellerPOItems)
        const sellerPOApprovals = approvals.filter(eachApproval => pmCompanyConfig.sellerPOApprovalTypeIds.includes(eachApproval.approvalTypeId))
        let requiredApprovals = getSellerPOApprovals({
            POApprovals: sellerPOApprovals,
            sellerPO: calculatedResult.sellerPO,
            sellerPOItems: calculatedResult.sellerPOItems,
            sellerCompanyDetails: relatedSellerCompanyDetails,
            buyerQuoteItems: buyerQuoteItems,
            companyCreditPeriods: companyCreditPeriods,
            sellerPIPunch: [],
            materialMasterData: allMaterialDetails,
            buyerReq: buyerReq,
            buyerPOItems: buyerPOItems,
            totalAmtFlag: true, //Reason for this??,
            nonRoutedSellerPOsInfo: nonRoutedSellerPOsInfo,
            sellerReqItems: props.sellerReqItems,
            materialMandatoryUseFromStock: materialMandatoryUseFromStock
        })
        setRequiredApprovals(requiredApprovals)
    }
    
    const template = (options) => {
        const toggleIcon = options.collapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up';
        const className = `${options.className} justify-content-between`;

        return (
            <div className={className} style={{ display: "flex", padding: "3px 10px", justifyContent: "", fontFamily: "Amazon Ember,Arial,sans-serif" }}>
                <div className="flex align-items-center">
                    <button className={options.togglerClassName} onClick={options.onTogglerClick}>
                        <span className={toggleIcon}></span>
                        <Ripple />
                    </button>
                    <p className="font-semibold text-xs">
                        {`${relatedSellerCompanyDetails?.firstName} ${relatedSellerCompanyDetails?.lastName ? ` ${relatedSellerCompanyDetails?.lastName}` : ''}  |  ${relatedSellerCompanyDetails?.emailId} | ${relatedSellerCompanyDetails?.companyName}(${relatedSellerCompanyDetails.branchName})`}
                    </p>
                </div>
            </div>
        )
    }

    const handleHSNCode = async (e) => {
        let HSNCodeDetails = []
        if (e.target.value.length > 4) {
            HSNCodeDetails = HSNMasterData?.filter(eachCode => eachCode.HSNCode === parseFloat(e.target.value))
        }

        let updatedDisplaySellerPOs = allDisplaySellerPOs.map(eachDisplaySellerPO => {
            if (eachDisplaySellerPO.displaySellerPOId === displaySellerPO.displaySellerPOId) {
                if (HSNCodeDetails.length === 1) {
                    eachDisplaySellerPO['logisticsHSNCode'] = e.target.value
                    eachDisplaySellerPO["HSNCodeGSTRates"] = [HSNCodeDetails?.[0]?.GSTRate]
                }
                else if (HSNCodeDetails.length > 1) {
                    const relatedGSTOptions = HSNCodeDetails.map(eachHSNCode => eachHSNCode.GSTRate)
                    eachDisplaySellerPO["HSNCodeGSTRates"] = relatedGSTOptions
                    eachDisplaySellerPO['logisticsHSNCode'] = e.target.value
                }
                else if (HSNCodeDetails.length === 0) {
                    eachDisplaySellerPO['logisticsHSNCode'] = e.target.value
                    eachDisplaySellerPO["HSNCodeGSTRates"] = [0]
                }
            }
            eachDisplaySellerPO.tdsSectionId = null
            return eachDisplaySellerPO
        })

        setDisplaySellerPOs(updatedDisplaySellerPOs)
    }

    const handleDisplaySellerPO = (e) => {
        const updatedDisplaySellerPOs = allDisplaySellerPOs.map(eachDisplaySellerPO => {
            if (eachDisplaySellerPO.displaySellerPOId === displaySellerPO.displaySellerPOId) {
                return { ...eachDisplaySellerPO, [e.target.name]: e.target.value }
            }
            return eachDisplaySellerPO
        })
        setDisplaySellerPOs(updatedDisplaySellerPOs)
    }

    const handleIncoTerms = (e) => {
        const updatedDisplaySellerPOs = allDisplaySellerPOs.map(eachDisplaySellerPO => {
            if (eachDisplaySellerPO.displaySellerPOId === displaySellerPO.displaySellerPOId) {
                return { ...eachDisplaySellerPO, [e.target.name]: e.target.value, shipAddrId: null }
            }
            return eachDisplaySellerPO
        })
        setDisplaySellerPOs(updatedDisplaySellerPOs)
    }

    const handleSellerBillAddrr = (id) => {
        const updatedDisplaySellerPOs = allDisplaySellerPOs.map(eachDisplaySellerPO => {
            if (eachDisplaySellerPO.displaySellerPOId === displaySellerPO.displaySellerPOId) {
                return { ...eachDisplaySellerPO, billAddrId: id }
            }
            return eachDisplaySellerPO
        })
        setDisplaySellerPOs(updatedDisplaySellerPOs)
    }

    const checkMaterialsAreVRC = async(data) => {
        setIsLoading(true)
        let vrcCheckAtSellerPORes = await vrcCheckAtSellerPOCreation(data)
        setIsLoading(false)
        if (vrcCheckAtSellerPORes.failure) {
            return dispatch(raiseToast({ severity: 'error', details: vrcCheckAtSellerPORes.data.error, life: 3000 }))
        }
        let newSellerReqMaterialIds = []
        let { sellerReqs, sellerReqItems } = vrcCheckAtSellerPORes.data
        if(sellerReqs && sellerReqs.length){
            let relatedNewSellerReqs = sellerReqs.filter(eachSellerReq => {
                let relatedSellerDetails = sellerCompanyDetails.find(eachCompany => eachCompany.companyId === eachSellerReq.companyId && eachCompany.sellerReqId === eachSellerReq.sellerReqId)
                if(!relatedSellerDetails){
                    return true
                }
            })
            if (relatedNewSellerReqs.length) {
                setIsLoading(true)
                const sellerDetailsRes = await getSellerDetailsBySellerReqs({ sellerReqs: relatedNewSellerReqs })
                setIsLoading(false)
                if (sellerDetailsRes.failure) {
                    return dispatch(raiseToast({ severity: 'error', summary: 'Sellers Names', detail: sellerDetailsRes.data.error, life: 3000 }))
                }
                let updatedCompanyDetails = _.compact(sellerDetailsRes?.data)

                setSellerCompanyDetails([...sellerCompanyDetails, ...updatedCompanyDetails])
            }

            props.setSellerReqs([...sellerReqs, ...props.sellerReqs])
        }
        if(sellerReqItems && sellerReqItems.length){
            let newSellerReqItems = sellerReqItems.map(eachSellerReqItem => {
                newSellerReqMaterialIds.push(eachSellerReqItem.materialId)
                return { ...eachSellerReqItem, isNewSellerReqItem: true}
            })
            props.setSellerReqItems([...newSellerReqItems, ...props.sellerReqItems])
        }
    
        return {newSellerReqMaterialIds}
    }
    
    const handleSubmitSellerPOValidations = async (e) => {
        const relatedVendorRateContracts = vendorRateContracts.filter(eachVendorRc => {
            const isBranchPresent = Object.keys(eachVendorRc.geoMap).includes(buyerReq.pmBranchId.toString())
            return isBranchPresent
        })

        if(relatedVendorRateContracts.length){
            const pmBillAddr = procmartCompanyBillAddrs.find(eachBillAddr => eachBillAddr.billAddrId === buyerPO.pmBillAddrId)
            const materialIds = displaySellerPOItems.map(eachSPOItem => eachSPOItem.materialId)
            let data = {
                buyerReqItems: null,
                relatedVendorRateContracts,
                buyerRequirement: buyerReq,
                pmBillAddr,
                materialIds
            }
            const { newSellerReqMaterialIds } = await checkMaterialsAreVRC(data)
            if(newSellerReqMaterialIds.length){
                const materialText = newSellerReqMaterialIds.length > 1 ? "MaterialIds" : "MaterialId"
                const materialIds = newSellerReqMaterialIds.join(", ")
                if(!window.confirm(`We have a vendor Rate Contract on ${materialText}.\nPlease review before proceeding.`)){
                    return false
                }
            }
        }

        let materialMissingSpecsAttributes = displaySellerPOItems.filter(eachMaterial => {
            const relatedMaterial = allMaterialDetails.find(eachMaterialDetail => eachMaterialDetail.materialId === eachMaterial.materialId)
            if (relatedMaterial.materialId.toString().length === 6) {
                let missingSpecsAttributes = []
                if (relatedMaterial.materialId.toString().length === 6 && materialSpecifications.length) {
                    const relatedMaterialSpecs = materialSpecifications.filter(
                        (spec) =>
                        relatedMaterial.categoryId === spec.categoryId &&
                        relatedMaterial.productName.toLowerCase() === spec.productName.toLowerCase() &&
                        relatedMaterial.variantName?.toLowerCase() === spec.variantName.toLowerCase() &&
                        !relatedMaterial.partialSpecsOnly
                    )

                    if (relatedMaterialSpecs.length) {
                        let productSpecificationJSON = []
                        if (relatedMaterial.productSpecificationJSON) {
                            productSpecificationJSON = relatedMaterial.productSpecificationJSON.map(jsonString => JSON.parse(jsonString))
                        }

                        relatedMaterialSpecs.forEach((spec) => {
                            if (spec.materialSpecificationMandatoryTypeId === 1) {
                                const hasAttribute = productSpecificationJSON.some(
                                    attr => attr.type?.toLowerCase() === spec.attribute.toLowerCase() && attr.value
                                )

                                if (!hasAttribute) {
                                    missingSpecsAttributes.push({
                                        name: spec.attribute,
                                        unit: spec.attributeUnit,
                                    })
                                }
                            }
                        })
                    }
                }

                if (missingSpecsAttributes.length) {
                    return true
                }
            }
        })

        if (materialMissingSpecsAttributes.length) {
            let materialIds = materialMissingSpecsAttributes.map(eachMaterial => eachMaterial.materialId)
            return dispatch(raiseToast({ severity: 'error', detail: `Please review the materials ${materialIds.join(", ")} with missing mandatory specification attributes.` }))
        }

        if(!displaySellerPO.paymentTerms){
            return dispatch(raiseToast({ severity: 'error', detail: `Payment terms are missing for company!` }))
        }

        Object.keys(displaySellerPO.paymentTerms).forEach(eachPaymentTerm => {
            displaySellerPO.paymentTerms[eachPaymentTerm] = parseFloat(displaySellerPO.paymentTerms[eachPaymentTerm])
        })

        if(bankAccounts.length && !displaySellerPO.prefBankAccountId && displaySellerPO.companyId !== displaySellerPO.pmCompanyId){
            return dispatch(raiseToast({ severity: 'error', detail: `Please select bank account` }))
        }

        if (displaySellerPOItems?.length === 0) {
            return dispatch(raiseToast({ severity: 'error', detail: `Please enter items for seller PO`, life: 3000 }))
        }

        if(displaySellerPO.paymentTerms["payPDCDelivery"] > 0 && relatedSellerCompanyDetails.preferredPaymentMode === 'BANK TRANSFER'){
            return dispatch(raiseToast({ severity: 'error', detail: `Seller has "BANK TRANSFER" as prefered payment option, can't have "PDC on Delivery" as payment term` }))
        }

        if((displaySellerPO.paymentTerms["payAdvPO"] > 0 || displaySellerPO.paymentTerms["payAdvDelivery"] > 0 || displaySellerPO.paymentTerms["payOnDelivery"] > 0) && relatedSellerCompanyDetails.preferredPaymentMode === 'CHEQUE'){
            return dispatch(raiseToast({ severity: 'error', detail: `Seller has "CHEQUE" as prefered payment option, can't have "Adv against PO", "Adv before Delivery" or "Pay against Delivery" as payment term` }))
        }

        // const isTDSEntered = displaySellerPOItems.some(eachPOItem => {
        //     if (!eachPOItem.tdsSectionId || (eachPOItem.tdsSectionId === 5 && !(parseFloat(eachPOItem.tdsValue) >= 0))) {
        //         dispatch(raiseToast({ severity: 'error', detail: `Please enter TDS value for material Id ${eachPOItem?.materialId}`, life: 3000 }))
        //         return true
        //     }
        //     return false
        // })

        // if (isTDSEntered) return

        if (pmCompanyConfig.defaultHSNCode){
            displaySellerPO.logisticsHSNCode = pmCompanyConfig.defaultHSNCode
        }

        if (parseFloat(displaySellerPO?.logisticsBeforeTax) && !displaySellerPO.logisticsHSNCode) return dispatch(raiseToast({ severity: 'error', detail: `Please enter HSN code for logistics`, life: 3000 }))

        if (displaySellerPO.logisticsHSNCode) {
            const HSNCodeDetails = HSNMasterData?.filter(eachCode => eachCode.HSNCode === parseFloat(displaySellerPO.logisticsHSNCode))
            if (HSNCodeDetails.length === 0) {
                return dispatch(raiseToast({ severity: 'error', detail: `Please enter a valid HSN code for logistics`, life: 3000 }))
            }
        }

        if (!displaySellerPO.incoTermId) {
            return dispatch(raiseToast({ severity: 'error', detail: 'Please select inco term', life: 3000 }))
        }

        if (parseFloat(paymentTermsTotal) !== 100) {
            return dispatch(raiseToast({ severity: 'error', detail: "Net total of payment terms should be 100", life: 3000 }))
        }

        if (!pmCompanyConfig.isTDSAutomated){
            if ((parseFloat(displaySellerPO?.logisticsBeforeTax) && !(parseFloat(displaySellerPO.logisticsTDSValue) >= 0))) {
                return dispatch(raiseToast({ severity: 'error', detail: `Please enter TDS value for logistics`, life: 3000 }))
            }
        }

        if (!displaySellerPO?.shipAddrId) {
            return dispatch(raiseToast({ severity: 'error', detail: 'Please select shipping address', life: 3000 }))
        }

        if (!displaySellerPO.billAddrId) {
            return dispatch(raiseToast({ severity: 'error', detail: "Please select billing address", life: 3000 }))
        }

        if (!displaySellerPO.pmBillAddrId) {
            return dispatch(raiseToast({ severity: 'error', detail: "Please select PM billing address", life: 3000 }))
        }

        if(displaySellerPO.billAddrId){
            const relatedBillAddrrs = relatedSellerCompanyDetails.sellerBillAddrrDetails.find(eachBillAddr => eachBillAddr.billAddrId === displaySellerPO.billAddrId)
            if(relatedBillAddrrs && !["URD", "URP"].includes(relatedBillAddrrs.gstinCode)){
                const updatedAt = new Date(relatedBillAddrrs.companyGSTIN.updatedAt)
                const currentDate = new Date()
                const updatedAtTimeDiff = Math.round((currentDate - updatedAt) / (1000 * 60 * 60 * 24))
                if(!pmCompanyConfig.isInternational){
                    if(updatedAtTimeDiff > 30 && !panAPITriggered){
                        //return dispatch(raiseToast({ severity: 'error', detail: `Please refresh seller gstins (last updated: ${updatedAtTimeDiff} days ago)`}))
                        return handleBillAddrsVerify() 
                    }
                }
                if([20].includes(relatedBillAddrrs.companyGSTIN.statusId)){
                    return dispatch(raiseToast({ severity: 'error', detail: `Selected seller GSTIN is blacklisted!`}))
                }
            }
            else {
                const isGSTApplied = displaySellerPOItems.some(eachSellerPOItem => eachSellerPOItem.GSTRate)
                if(isGSTApplied){
                    return dispatch(raiseToast({severity: 'error', detail: "GST cannot be applied to a URD seller"}))
                }
            }
        }

        const invalidSellerPOItem = displaySellerPOItems.some(eachPOItem => {
            if(!eachPOItem.unitPrice){
                dispatch(raiseToast({ severity: 'error', detail: `Please enter unit price for material ID ${eachPOItem.materialId}`, life: 3000 }))
                return true
            }

            if (!eachPOItem.GSTRate && eachPOItem.GSTRate !== 0) {
                dispatch(raiseToast({ severity: 'error', detail: `Please enter GST for material ID ${eachPOItem.materialId}`, life: 3000 }))
                return true
            }

            const relatedHSNCode = HSNMasterData.find(eachHSNCode => eachHSNCode.HSNCode === parseInt(eachPOItem.HSNCode))
            if (!relatedHSNCode) {
                dispatch(raiseToast({ severity: 'error', detail: `Please enter Valid HSN Code for material ID ${eachPOItem.materialId}` }))
                return true
            }

            return false
        })

        if(invalidSellerPOItem) return

        setVisiblePaymentTermsRemarks(true)

        // if(!displaySellerPO.isApprovalReq){
        //     setVisiblePaymentTermsRemarks(true)
        // }
        // else{
        //     await handleSubmitSellerPO()
        // }
    }

    const handleSubmitSellerPO = async () => {

        let windowMessage = "Are you sure you want to create a seller PO?"
        const relatedSellerBillAddr = relatedSellerCompanyDetails.sellerBillAddrrDetails.find(each => each.billAddrId === displaySellerPO.billAddrId)

        if(relatedSellerBillAddr?.gstinCode === "URD"){
            windowMessage = "You have selected URD Billing Addr. Are you sure you want to continue?"
        }
        else{
            if([21, 22].includes(relatedSellerBillAddr.companyGSTIN.statusId)){
                windowMessage = "This Vendor’s VP are on hold - the seller PO will get created, but payments can only happen after the VP hold is released by Finance team"
            }
        }
        let isUnitPriceApprovalReq = false
        isUnitPriceApprovalReq = displaySellerPOItems?.some(eachDisplaySellerPOItem => {
            const relatedBuyerQuoteItems = buyerQuoteItems?.filter(eachBuyerQuoteItem => eachBuyerQuoteItem?.buyerReqItemId === eachDisplaySellerPOItem?.buyerReqItemId && eachBuyerQuoteItem?.statusId === 1 && eachBuyerQuoteItem?.totReqQty > 0)
            let totalSellerQuotPrice = 0
            relatedBuyerQuoteItems?.map(eachBuyerQuoteItem => {
                totalSellerQuotPrice += parseFloat(eachBuyerQuoteItem?.bQuotSellerPrice)
            })
            let avgSellerQuotPrice = round(totalSellerQuotPrice / (relatedBuyerQuoteItems?.length))
            return eachDisplaySellerPOItem?.unitPrice > avgSellerQuotPrice && displaySellerPO?.companyId !== displaySellerPO?.pmCompanyId
        })

        let updatedSellerPOItems = displaySellerPOItems.map(item => {

            let updatedSPOItem = { ...item}
            if([3, 11].includes(item.followUpStatusId)){
                updatedSPOItem.remarks = "No followUp required"
                updatedSPOItem.followUpRemarks = ["No followUp required"]
                updatedSPOItem.followUpRemarksTS = [moment(new Date()).format("YYYY-MM-DD")]
            }
            return updatedSPOItem

            // return {
            //     ...item,
            //     // remarks: "first FollowUp",
            //     // followUpRemarks: ["first FollowUp"],
            //     // followUpRemarksTS: [moment(new Date()).format("YYYY-MM-DD")]
            // }
        })

        const isServiceHSNsProductsExists = updatedSellerPOItems.some(eachPOItem => {
            if(eachPOItem.HSNCode.toString().slice(0, 2) === '99' && eachPOItem.HSNCode.toString().length === 6){
                return true
            }
            return false
        })

        let updatedDisplaySellerPO = displaySellerPO
        
        if (pmCompanyConfig.isTDSAutomated){
            let tdsSection 
            if(displaySellerPO.companyId !== displaySellerPO.pmCompanyId){
                if (isServiceHSNsProductsExists){
                    if (relatedSellerCompanyDetails.tdsSectionId === 1 || !relatedSellerCompanyDetails.tdsSectionId) {
                        return dispatch(raiseToast({ severity: 'error', detail: "Services are not enabled for the vendor - please enable by selecting correct service Type in Companies Page.", life: 3000 }))
                    } else {
                        tdsSection = tdsSections?.find(eachTDSSection => eachTDSSection.tdsSectionId === relatedSellerCompanyDetails?.tdsSectionId)
                    }
                } else if (relatedSellerCompanyDetails.tdsSection194q){
                    tdsSection = tdsSections.find(eachTDSSection => eachTDSSection.tdsSectionId === 1)
                } else {
                    tdsSection = tdsSections.find(eachTDSSection => eachTDSSection.tdsSectionId === 8)
                }
            } else {
                tdsSection = tdsSections.find(eachTDSSection => eachTDSSection.tdsSectionId === 8)
            }

            let tdsValue
            if (relatedSellerCompanyDetails.panCode && relatedSellerCompanyDetails.panCode[3] === "P"){
                tdsValue = tdsSection.individualTDSRate
            }else{
                tdsValue = tdsSection.othersTDSRate
            }

            updatedDisplaySellerPO = {...updatedDisplaySellerPO, tdsSectionId: tdsSection.tdsSectionId}
            updatedSellerPOItems = updatedSellerPOItems.map(eachSellerPOItem => {
                eachSellerPOItem.tdsSectionId = tdsSection.tdsSectionId
                eachSellerPOItem.tdsSection = tdsSection.tdsSectionName
                if (relatedSellerCompanyDetails.panCode && relatedSellerCompanyDetails.panCode[3] === "P"){
                    eachSellerPOItem.tdsValue = tdsSection.individualTDSRate
                    updatedDisplaySellerPO.tdsValue = tdsSection.individualTDSRate
                }else{
                    eachSellerPOItem.tdsValue = tdsSection.othersTDSRate
                    updatedDisplaySellerPO.tdsValue = tdsSection.othersTDSRate
                }
                return eachSellerPOItem
            })
        }else{
            let isTDSEntered = updatedSellerPOItems.every(eachSellerPOItem => {
                return eachSellerPOItem.tdsValue
            })

            if (!isTDSEntered){
                return dispatch(raiseToast({ severity: 'error', detail: "Please enter tds value for every item.", life: 3000 }))
            }
        }
        let approvalId = null

        if (!buyerReq.isRouted && pastSellerPOsInfo && parseInt(pastSellerPOsInfo.approvalRelatedSellerPOCount) >= 3 && displaySellerPO.isApprovalReq){
            return dispatch(raiseToast({ severity: 'error', detail: "Frequent Seller-PO Payment terms change is not encouraged. Please Update branch/ company level payment terms by contacting Ops admin, or proceed with default payment terms.", life: 3000 }))
        }

        const isMaterialMandatoryAvailable = updatedSellerPOItems.find(eachSellerPOItem => {
            const relatedMaterialMandatoryUseFromStock = materialMandatoryUseFromStock.find(eachMandatoryMaterial => eachMandatoryMaterial.materialId === eachSellerPOItem.materialId)

            const isUseStockMaterialExist = stockMaterials.find(eachStockMaterial => eachStockMaterial.materialId === eachSellerPOItem.materialId)
            if(relatedMaterialMandatoryUseFromStock && isUseStockMaterialExist){
                return true
            }

            return false
        })

        let isSellerPOBrandCertificateApprovalNeeded = false
        let isBrandCertificateMissing = false
        let certificateMissingBrands = []
        updatedSellerPOItems.map(eachSellerPOItem => {
            const relatedMaterial = allMaterialDetails.find(eachMaterialDetail => eachMaterialDetail.materialId === eachSellerPOItem.materialId)
            const relatedMaterialBrand = materialBrands.find(eachMaterialBrand => eachMaterialBrand.brandId === relatedMaterial.brandId)
            if (relatedMaterialBrand.config?.certificateProofMandatory){
                const relatedCompanyBrandCertificate = companyCertificates.find(eachCompanyCertificate => eachCompanyCertificate.companyId === displaySellerPO.companyId && eachCompanyCertificate.entityId === relatedMaterialBrand.brandId && eachCompanyCertificate.statusId === 1 && moment(new Date()).format("YYYY-MM-DD") <= eachCompanyCertificate.expiryDate)
                if (!relatedCompanyBrandCertificate){
                    isBrandCertificateMissing = true
                    certificateMissingBrands.push(relatedMaterialBrand.brandName)
                }
            }
        })


        if ((!buyerReq.isRouted || displaySellerPO.companyId !== displaySellerPO.pmCompanyId) && isBrandCertificateMissing){
            isSellerPOBrandCertificateApprovalNeeded = true
        }
        // else if (certificateMissingBrands.length){
        //     return dispatch(raiseToast({ severity: 'error', detail: `Certificate not available or approved for ${certificateMissingBrands.join(",")} brand(s).Seller po creation cannot be proceeded.`, life: 3000 }))
        // }

        const calculatedResult = calculateSellerPO(updatedDisplaySellerPO, updatedSellerPOItems)
        if (isUnitPriceApprovalReq || displaySellerPO?.isApprovalReq || calculatedResult?.sellerPO?.totalItemAmountWithTax > 99999 || (isMaterialMandatoryAvailable && buyerReq.orderTypeId !== 3) || isSellerPOBrandCertificateApprovalNeeded){
            let newWindowMessage = ""
            if (isMaterialMandatoryAvailable && buyerReq.orderTypeId !== 3){
                newWindowMessage += 'Mandatory Materials are present.'
            }
            if (isSellerPOBrandCertificateApprovalNeeded){
                newWindowMessage += `Brand certificates were missing for brands ${certificateMissingBrands.join(",")}. `
            }else if (certificateMissingBrands.length){
                newWindowMessage += `Certificate(s) is/are not available or approved for ${certificateMissingBrands.join(",")} brand(s).`
            }
            newWindowMessage += "Approvals are required for this PO. Do you want to continue.?"
            
            windowMessage = newWindowMessage
        }

        if (window.confirm(windowMessage) == true) {
            //selecting most repeated shipAddrId

            setIsPageLoading(true)
            setVisiblePaymentTermsRemarks(false)
            let isStockSellerPO = displaySellerPO?.companyId === displaySellerPO.pmCompanyId ? true : false
            setIsLoading(true)

            const sellerPOSubmitRes = await insertSellerPO({ newSellerPO: calculatedResult.sellerPO, bulkSellerPOItems: calculatedResult.sellerPOItems, isStockSellerPO: isStockSellerPO, prevSellerPOs: prevSellerPOs })
            if (sellerPOSubmitRes?.failure) {
                setIsPageLoading(false)
                setIsLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: 'Seller PO creation failed', detail: sellerPOSubmitRes.data.error, life: 3000 }))
            }
            
            if (sellerPOSubmitRes.data.sellerPO && displaySellerPO.isApprovalReq) {
                let presentCreditPeriod = companyCreditPeriods?.find(eachCompanyPeriod => eachCompanyPeriod?.creditPeriodId === displaySellerPO?.paymentTerms?.creditPeriodId)
                let previousCreditPeriod = companyCreditPeriods?.find(eachCompanyPeriod => eachCompanyPeriod?.creditPeriodId === displaySellerPO?.masterPaymentTerms?.creditPeriodId)
                
               
                // if(presentCreditPeriod?.creditPeriodId === previousCreditPeriod?.creditPeriodId){
                //     approvalId = 21
                //     if(previousCreditPeriod.payCredit || previousCreditPeriod.payPDCDelivery){
                //         if(relatedSellerCompanyDetails.pastFiveSellerPOs.length === 5 && previousCreditPeriod.creditPeriodId < 8){
                //             approvalId = 30
                //         }
                //     }
                // }
                // else if(presentCreditPeriod?.creditPeriodId < previousCreditPeriod?.creditPeriodId){
                //     if (presentCreditPeriod?.creditPeriodId <  7){
                //         approvalId = 31
                //     }else{
                //         approvalId = 30
                //     }
                // }
                /*
                if (!buyerReq.isRouted){
                    if(nonRoutedSellerPOsInfo && parseInt(nonRoutedSellerPOsInfo.sellerPOCount) >= 5 && parseInt(nonRoutedSellerPOsInfo.totalAmount) > 200000){
                        approvalId = 21
                    }
                }else {
                    if(previousCreditPeriod.payCredit || previousCreditPeriod.payPDCDelivery){
                        if(relatedSellerCompanyDetails.pastFiveSellerPOs.length === 5 && previousCreditPeriod.creditPeriodId < 8){
                            approvalId = 30
                        }
                    }   
                }
                let newApprovalInstance = {
                    approvalId: approvalId,
                    docNo: sellerPOSubmitRes.data.sellerPO.docNo,
                    parentDocNo: displaySellerPO.parentDocNo,
                    approvedMetrics: { paymentTerms: displaySellerPO.paymentTerms },
                    sellerCompanyId: displaySellerPO.companyId,
                    buyerCompanyId: selectedReq?.companyId,
                    pmBranchId: displaySellerPO.pmBranchId,
                    docId: sellerPOSubmitRes.data.sellerPO.sellerPOId,
                    docTypeId: 15,
                    statusId: 12,
                    createdBy: userDetails.userId,
                    remarks: paymentTermsRemarks ? paymentTermsRemarks : null
                }

                const newApprovalInstacesRes = await insertApprovalInstances({ requestedApprovals: [newApprovalInstance] })
                if (newApprovalInstacesRes.failure) {
                    setIsPageLoading(false)
                    dispatch(raiseToast({ severity: 'error', detail: newApprovalInstacesRes.data.error, life: 3000 }))
                }
                */
            }

            setIsPageLoading(false)
            setIsLoading(false)
            navigate(`/sellerpo/${sellerPOSubmitRes?.data?.sellerPO?.sellerPOId}`)
        }
    }

    const handleLogisticsTDSChange = (e) => {
        const updatedDisplaySellerPOs = allDisplaySellerPOs.map(eachDisplaySellerPO => {
            if (eachDisplaySellerPO.displaySellerPOId === displaySellerPO.displaySellerPOId) {
                return { ...eachDisplaySellerPO, logisticsTDSValue: e.target.value, logisticsTDSSection: 'Other' }
            }
            return eachDisplaySellerPO
        })
        setDisplaySellerPOs(updatedDisplaySellerPOs)
    }

    const handlePaymentTermsChange = (event) => {
        if (event.target.name) {
            let updatedDisplaySellerPOs = allDisplaySellerPOs.map(eachDisplaySellerPO => {
                if (displaySellerPO.displaySellerPOId === eachDisplaySellerPO.displaySellerPOId) {
                    const payment_details = eachDisplaySellerPO.paymentTerms ? JSON.parse(JSON.stringify(eachDisplaySellerPO.paymentTerms)) : {}
                    payment_details[event.target.name] = event.target.value
                    eachDisplaySellerPO.paymentTerms = payment_details
                }
                return eachDisplaySellerPO
            })

            updatedDisplaySellerPOs = handlePaymentTermsApprovalChange(event.target.name, event.target.value)

            setDisplaySellerPOs(updatedDisplaySellerPOs)
        }
    }

    const handlePaymentTermsRemarksSubmitClick = async () => {
        if(displaySellerPO.isApprovalReq && !paymentTermsRemarks){
            return dispatch(raiseToast({ severity: 'error', detail: "Please enter remarks for payment terms approval", life: 3000 }))
        }
        
        await handleSubmitSellerPO()
    }

    const handlePaymentTermsApprovalChange = (name, value) => {
        let isApprovalReq = false
        const updatedDisplaySellerPOs = allDisplaySellerPOs.map(eachDisplaySellerPO => {
            if (displaySellerPO.displaySellerPOId === eachDisplaySellerPO.displaySellerPOId) {
                let masterPaymentTerms = eachDisplaySellerPO.masterPaymentTerms ? eachDisplaySellerPO.masterPaymentTerms : {}

                if (name !== "creditPeriodId") {

                } else {
                    const previousCreditPeriodId = masterPaymentTerms.creditPeriodId ? parseInt(masterPaymentTerms.creditPeriodId) : 0
                    if (previousCreditPeriodId > parseInt(value)) {
                        isApprovalReq = true
                    }
                }

                if (name !== "creditPeriodId" && value >= 0) {

                    let paymentTermNames = ['payAdvPO', 'payAdvDelivery', 'payPDCDelivery', 'payOnDelivery', 'payCredit']

                    let paymentTermShortName = name
                    let previousValue = masterPaymentTerms[paymentTermShortName]

                    let masterPaymentTermsPercentagesArr = []
                    paymentTermNames.map(termName => {
                        let percentage = masterPaymentTerms[termName]
                        if (percentage) {
                            masterPaymentTermsPercentagesArr.push(percentage)
                        } else {
                            masterPaymentTermsPercentagesArr.push(0)
                        }
                    })

                    let availablePaymentPercentage = 0
                    let previousTermExist = false

                    let currentPaymentTermIndex = paymentTermNames.findIndex(term => {
                        if (name === term) {
                            return true
                        }
                        return false
                    })

                    masterPaymentTermsPercentagesArr.map((termPercentage, index) => {
                        if (index <= currentPaymentTermIndex) {
                            availablePaymentPercentage += termPercentage
                            availablePaymentPercentage = parseFloat(parseFloat(availablePaymentPercentage).toFixed(2))
                            if (index < currentPaymentTermIndex) {
                                previousTermExist = true
                            }
                        }
                    })

                    if (name === 'payAdvPO') {
                        if (parseFloat(value) > previousValue) {
                            isApprovalReq = true
                        }
                    } else if (name === 'payAdvDelivery') {
                        if (parseFloat(value) > availablePaymentPercentage) {
                            isApprovalReq = true
                        }
                    } else if (name === 'payPDCDelivery') {
                        if (parseFloat(value) > availablePaymentPercentage) {
                            isApprovalReq = true
                        }
                    } else if (name === 'payOnDelivery') {
                        if (parseFloat(value) > availablePaymentPercentage) {
                            isApprovalReq = true
                        }
                    } else if (name === 'payCredit') {
                        if (parseFloat(value) < previousValue) {
                            isApprovalReq = true
                        }
                    }
                }
            }
            return { ...eachDisplaySellerPO, isApprovalReq: isApprovalReq }
        })

        return updatedDisplaySellerPOs
    }

    const handleProcmartState = (e) => {

        const updatedDisplaySellerPOs = allDisplaySellerPOs.map(eachDisplaySellerPO => {
            if (eachDisplaySellerPO.displaySellerPOId === displaySellerPO.displaySellerPOId) {
                return { ...eachDisplaySellerPO, [e.target.name]: e.target.value, pmBillAddrId: null }
            }
            return eachDisplaySellerPO
        })
        setDisplaySellerPOs(updatedDisplaySellerPOs)
    }

    const getIsWarehouseShipAddr = (sellerPOItems) => {
        const shipAddrIds = sellerPOItems.map(eachShipAddr => eachShipAddr.shipAddrId)

        const pmShipAddrIds = companyWarehouses.map(eachWarehouse => eachWarehouse.shipAddrId)
        const isWarehouseShipAddr = shipAddrIds.some(eachShipAddrId => {
            if (pmShipAddrIds.includes(eachShipAddrId)) {
                return true
            }
            return false
        })

        return isWarehouseShipAddr
    }

    const handleShippingAddress = (id) => {
        const updatedDisplaySellerPOs = allDisplaySellerPOs.map(eachDisplaySellerPO => {
            if (eachDisplaySellerPO.displaySellerPOId === displaySellerPO.displaySellerPOId) {
                return { ...eachDisplaySellerPO, shipAddrId: id }
            }
            return eachDisplaySellerPO
        })
        setDisplaySellerPOs(updatedDisplaySellerPOs)
    }

    const handlePMBillAddrr = (id) => {
        const updatedDisplaySellerPOs = allDisplaySellerPOs.map(eachDisplaySellerPO => {
            if (eachDisplaySellerPO.displaySellerPOId === displaySellerPO.displaySellerPOId) {
                return { ...eachDisplaySellerPO, pmBillAddrId: id }
            }
            return eachDisplaySellerPO
        })
        setDisplaySellerPOs(updatedDisplaySellerPOs)
    }

    const handleBillAddrsVerify = async () => {
        if(!relatedSellerCompanyDetails.panCode){
            return dispatch(raiseToast({ severity: 'error', detail: 'PAN Code missing on company'}))
        }

        setIsLoading(true)
        setpanAPITriggered(true)
        const companyBillAddrsRes = await getCompanyBillAddrsByPanCode({panCode: relatedSellerCompanyDetails.panCode.trim(), companyId: relatedSellerCompanyDetails.companyId})
        if(companyBillAddrsRes.failure){
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Company Bill Addrs', detail: companyBillAddrsRes.data.error}))
        }

        let updatedSellerCompanyDetails = sellerCompanyDetails.map(eachSellerDetails => {
            if (eachSellerDetails.companyId === companyBillAddrsRes.data.companyId) {
                const updatedBillAddrs = eachSellerDetails.sellerBillAddrrDetails.map(eachBillAddr => {
                    const relatedBillAddrrs = companyBillAddrsRes.data.companyBillAddrs.find(eachCompanyCBillAddr => eachCompanyCBillAddr.billAddrId === eachBillAddr.billAddrId)
                    if(relatedBillAddrrs){
                        return {...eachBillAddr, ...relatedBillAddrrs}
                    }
                    return eachBillAddr
                })
                eachSellerDetails.sellerBillAddrrDetails = updatedBillAddrs
            }
            return eachSellerDetails
        })

        setSellerCompanyDetails(updatedSellerCompanyDetails)

        const updatedDisplaySellerPOs = allDisplaySellerPOs.map(eachDisplaySellerPO => {
            if (eachDisplaySellerPO.displaySellerPOId === displaySellerPO.displaySellerPOId) {
                return { ...eachDisplaySellerPO, billAddrId: null }
            }
            return eachDisplaySellerPO
        })
        setDisplaySellerPOs(updatedDisplaySellerPOs)
        setIsLoading(false)
    }

    const handleOnChangeBankAccount = (event) => {
        const updatedDisplaySellerPOs = allDisplaySellerPOs.map(eachDisplaySellerPO => {
            if (eachDisplaySellerPO.displaySellerPOId === displaySellerPO.displaySellerPOId) {
                return { ...eachDisplaySellerPO, prefBankAccountId: event.target.value }
            }
            return eachDisplaySellerPO
        })
        setDisplaySellerPOs(updatedDisplaySellerPOs)
    }

    const gsts = [...displaySellerPO.logisticsGSTRates, ...displaySellerPO.HSNCodeGSTRates]
    const updatedGSTOptions = gstOptions.filter(eachGST => gsts.includes(eachGST.value))

    let updatedTDSOptions = []
    if (relatedSellerCompanyDetails?.tdsSection194q) {
        updatedTDSOptions = [tdsOptions[3]]
    } else {
        if (relatedSellerCompanyDetails?.panCode?.[3] === "P") {

            if (displaySellerPO?.logisticsHSNCode?.length >= 2 && displaySellerPO?.logisticsHSNCode?.slice(0, 2) === '99') {
                updatedTDSOptions = [tdsOptions[1], tdsOptions[2], tdsOptions[4]]
            } else {
                updatedTDSOptions = [tdsOptions[0], tdsOptions[4]]
            }
        } else {
            tdsOptions = tdsOptions.map(eachOpt => {
                if (eachOpt?.tdsSection === "194C") {
                    return { ...eachOpt, displayTDSSection: '194C | 2%', tdsValue: 2 }
                }
                return eachOpt
            })

            if (displaySellerPO?.logisticsHSNCode?.length >= 2 && displaySellerPO?.logisticsHSNCode?.slice(0, 2) === '99') {
                updatedTDSOptions = [tdsOptions[1], tdsOptions[2], tdsOptions[4]]
            } else {
                updatedTDSOptions = [tdsOptions[0], tdsOptions[4]]
            }
        }
    }

    //Payment terms
    let paymentTermsTotal = 0
    let missingMasterPaymentTerms = false
    if(displaySellerPO.paymentTerms){
        Object.keys(displaySellerPO.paymentTerms).forEach(eachKey => {
            if (eachKey !== "creditPeriodId") paymentTermsTotal += parseFloat(displaySellerPO.paymentTerms[eachKey])
        })
    }
    else{
        missingMasterPaymentTerms = true
    }

    const relatedShipAddrIds = displaySellerPOItems.map(eachSellerPOItem => eachSellerPOItem.shipAddrId)
    const relatedPMShipAddrs = procmartShipAddrs.filter(eachShipAddr => relatedShipAddrIds.includes(eachShipAddr.shipAddrId))

    const isWarehouseShipAddr = getIsWarehouseShipAddr(displaySellerPOItems)

    const relatedPMBillAddrs = procmartCompanyBillAddrs.filter(eachBillAddr => eachBillAddr.stateId === displaySellerPO?.pmStateId)

    const isHSNEntryAllowed = pmCompanyConfig.HSNEntryAllowed

    const sellerBillAddress = relatedSellerCompanyDetails.sellerBillAddrrDetails.filter(eachBillAddr => eachBillAddr.GSTINStatus === "ACTIVE")

    const displaySellerPOItemMaterialIds = displaySellerPOItems.map(eachDisplaySellerPOItem => eachDisplaySellerPOItem.materialId)
    const useStockMaterials = stockMaterials.filter(eachStockMaterial => displaySellerPOItemMaterialIds.includes(eachStockMaterial.materialId))
    const useStockMaterialIds = useStockMaterials.map(eachUseStockMaterial => eachUseStockMaterial.materialId)

    return (
        <>
            <PaymentTermsApprovalRemarks 
                paymentTermsRemarks={paymentTermsRemarks}
                handleDisplaySellerPO={handleDisplaySellerPO}
                setPaymentTermsRemarks={setPaymentTermsRemarks}
                setVisiblePaymentTermsRemarks={setVisiblePaymentTermsRemarks}
                handlePaymentTermsRemarksSubmitClick={handlePaymentTermsRemarksSubmitClick}
                visiblePaymentTermRemarks={visiblePaymentTermRemarks}
                buyerPoCreatedAtDate={buyerPoCreatedAtDate}
                isApprovalReq={displaySellerPO.isApprovalReq}
            />
            <div className="mb-3">
                <Panel headerTemplate={template} toggleable>
                    {
                        useStockMaterialIds.length && displaySellerPO.companyId !== userDetails.PMCompanyDetails.companyId && buyerReq.orderTypeId !== 3? 
                            <Messages messages={`Material Id(s) ${useStockMaterialIds.join(', ')} available in stock. Please proceed from USE STOCK!`} sticky severity="error"/>
                        : 
                            null
                    }
                    {displaySellerPOItems.map(eachSellerPOItem => {
                        const materialDetails = allMaterialDetails.find(eachMaterialCode => eachMaterialCode.materialId === eachSellerPOItem.materialId)
                        const relatedSellerReqItem = props.sellerReqItems.find(eachSellerReqItem => eachSellerReqItem.sellerReqItemId === eachSellerPOItem.sellerReqItemId)
                        
                        return (
                            <DisplaySellerPOItem
                                key={`displaySellerPOItem-${eachSellerPOItem.displaySellerPOItemId}`}
                                displaySellerPOItem={eachSellerPOItem}
                                materialDetails={materialDetails}
                                allDisplaySellerPOItems={displaySellerPOItems}
                                setDisplaySellerPOItems={setDisplaySellerPOItems}
                                relatedSellerCompanyDetails={relatedSellerCompanyDetails}
                                displaySellerPO={displaySellerPO}
                                buyerQuoteItems={buyerQuoteItems}
                                sellerReqItem={relatedSellerReqItem}
                            />
                        )
                    })}
                    <div className="hr-line"></div>
                    <p className="font-semibold text-xs m-0 mr-3 mt-2">Logistics Charge</p>
                    <div className="flex align-items-center">
                        <div className="flex flex-column mr-2">
                            <TextInputField name="logisticsBeforeTax" value={displaySellerPO?.logisticsBeforeTax} labelText="Amount" keyfilter="pnum" onChange={handleDisplaySellerPO} />
                        </div>
                        {
                            isHSNEntryAllowed ?
                            <div className="flex flex-column">
                                <TextInputField name="logisticsHSNCode" value={displaySellerPO?.logisticsHSNCode} labelText="HSN" keyfilter="pnum" errorBorder={parseFloat(displaySellerPO?.logisticsBeforeTax) && !displaySellerPO.logisticsHSNCode} onChange={handleHSNCode} />
                            </div>
                            :
                            null
                        }
                        <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                            <DropDownField name="logisticsGSTRate" value={displaySellerPO?.logisticsGSTRate} options={updatedGSTOptions} labelText={pmCompanyConfig.GSTRateLabel} optionLabel="label" optionValue="value" onChange={handleDisplaySellerPO} disabled={!relatedSellerCompanyDetails?.gstinCode} />
                        </div>
                        {
                            pmCompanyConfig.isTDSAutomated ?
                            null
                            :
                            <div className="flex flex-column">
                                <TextInputField name="logisticsTDSValue" value={displaySellerPO?.logisticsTDSValue} labelText="Logistics TDS Value" keyfilter="pnum" errorBorder={parseFloat(displaySellerPO?.logisticsBeforeTax) && !displaySellerPO.logisticsTDSValue} onChange={handleLogisticsTDSChange} />
                            </div>
                        }
                        {/* {displaySellerPO.tdsSectionId === 5 &&
                            <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                                <TextInputField name="otherTDSAmount" value={displaySellerPO.logisticsTDSValue} labelText='Other' onChange={handleLogisticsOtherTDSCharge} keyfilter="num" errorBorder={!displaySellerPO.logisticsTDSValue} />
                            </div>
                        } */}
                    </div>
                    <div className="flex">
                        <p className="font-semibold text-xs m-0 mr-3 mt-2">Payment Terms<span style={{ color: 'red', marginLeft: '1px' }}>* {missingMasterPaymentTerms && '(Payment terms missing for company)'}</span></p>
                        {
                            displaySellerPO.isApprovalReq ?
                                <div className="ml-1">
                                    <img src="https://procmart-dev.s3.ap-south-1.amazonaws.com/requirementSourceDocument/0370048a-e0db-4fa2-9ef9-ab84df0af52a.png" className="selpo-payment-terms-approval-btn-tooltip tooltip cursor-auto" style={{ height: "25px", width: "25px" }} />
                                    <Tooltip target={'.selpo-payment-terms-approval-btn-tooltip'} position='top' style={{ width: "200px" }}>
                                        <div className="w-100 flex flex-column">
                                            <p className="m-0">Bad payment terms require approval</p>
                                        </div>
                                    </Tooltip>
                                </div> : null
                        }
                    </div>
                    <div className="grid p-2 align-items-center pl-0">
                        <div className="flex flex-column col-12  lg:col-2 lg:mb-0">
                            <TextInputField name="payAdvPO" labelText="Adv against PO (%)" keyfilter={"pnum"} value={displaySellerPO?.paymentTerms?.payAdvPO} onChange={handlePaymentTermsChange} disabled={missingMasterPaymentTerms} />  {/*onBlur={handlePaymentTermsApproval}*/}
                        </div>
                        <div className="flex flex-column col-12  lg:col-2 lg:mb-0 pl-0">
                            <TextInputField name="payAdvDelivery" labelText="Adv before Delivery (%)" keyfilter={"pnum"} value={displaySellerPO?.paymentTerms?.payAdvDelivery} onChange={handlePaymentTermsChange} disabled={missingMasterPaymentTerms} />   {/*onBlur={handlePaymentTermsApproval}*/}
                        </div>
                        <div className="flex flex-column col-12  lg:col-2 lg:mb-0 pl-0">
                            <TextInputField name="payPDCDelivery" labelText="PDC on Delivery (%)" keyfilter={"pnum"} value={displaySellerPO?.paymentTerms?.payPDCDelivery} onChange={handlePaymentTermsChange} disabled={missingMasterPaymentTerms} />  {/*onBlur={handlePaymentTermsApproval}*/}
                        </div>
                        <div className="flex flex-column col-12  lg:col-2 lg:mb-0 pl-0">
                            <TextInputField name="payOnDelivery" labelText="Pay against Delivery (%)" keyfilter={"pnum"} value={displaySellerPO?.paymentTerms?.payOnDelivery} onChange={handlePaymentTermsChange} disabled={missingMasterPaymentTerms} />  {/*onBlur={handlePaymentTermsApproval}*/}
                        </div>
                        <div className="flex flex-column col-12  lg:col-1 lg:mb-0 pl-0">
                            <TextInputField name="payCredit" labelText="Credit (%)" keyfilter={"pnum"} value={displaySellerPO?.paymentTerms?.payCredit} onChange={handlePaymentTermsChange} disabled={missingMasterPaymentTerms} />   {/*onBlur={handlePaymentTermsApproval}*/}
                        </div>
                        {
                            parseFloat(displaySellerPO?.paymentTerms?.payCredit) > 0 || parseFloat(displaySellerPO?.paymentTerms?.payPDCDelivery) > 0 ?
                                <div className="flex flex-column col-12 lg:col-2 lg:mb-0">
                                    <DropDownField name="creditPeriodId" labelText="Credit Period" options={companyCreditPeriods} optionLabel="creditPeriodName" optionValue="creditPeriodId" value={displaySellerPO?.paymentTerms?.creditPeriodId} onChange={(e) => handlePaymentTermsChange(e)} />  {/*onBlur={handlePaymentTermsApproval}*/}
                                </div> : ""
                        }
                        <div className="flex flex-column col-12 lg:col-1">
                            <p className={`font-bold text-${paymentTermsTotal === 100 ? 'green-600' : 'red-500'}`}>{paymentTermsTotal}</p>
                        </div>
                    </div>
                    <div className="hr-line"></div>
                    <div className="m-0">
                        <p className="font-semibold text-xs mb-1 mt-1">Seller Bank Accounts<span style={{ color: 'red', marginLeft: '1px' }}>*</span></p>
                        {
                            bankAccounts.length === 0 && displaySellerPO.companyId !== displaySellerPO.pmCompanyId ?
                                <p className='mb-2 mt-0 ml-2 font-semibold billing-address-msg text-700 text-red-500'>
									Bank Accounts are not found.
									<a style={{ color: '#00baaa' }} target="_blank" href={`/company/bank_details/${displaySellerPO.companyId}`}> Click here </a>
									to add bank account.
								</p>
                                :
                                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                    <DropDownField name="prefBankAccountId" options={bankAccounts} value={displaySellerPO.prefBankAccountId} optionLabel={eachBankAccount => `${eachBankAccount.bankName} - ${eachBankAccount.accNo}`} optionValue="bankAccId" onChange={(e) => handleOnChangeBankAccount(e)} />
                                </div>
                        }
                    </div>
                    <div className="hr-line"></div>
                    <p className="font-semibold text-xs m-0 mr-3 mt-3">PM State<span style={{ color: 'red', marginLeft: '1px' }}>*</span></p>
                    <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                        <DropDownField name="pmStateId" options={relatedPMStates} value={displaySellerPO.pmStateId} optionLabel="stateName" optionValue="stateId" onChange={handleProcmartState} disabled={displaySellerPO?.companyId === displaySellerPO?.pmCompanyId} />
                    </div>
                    <div className="m-0">
                        <p className="font-semibold text-xs mb-2 mt-1">PM billing address<span style={{ color: 'red', marginLeft: '1px' }}>*</span></p>
                        <BillingAddressCards billingAddresses={relatedPMBillAddrs} selectedAddressId={displaySellerPO?.pmBillAddrId} handleBillingAddress={handlePMBillAddrr} />  {/* disabled={true} */}
                    </div>
                    <div className="hr-line"></div>
                    <p className="font-semibold text-xs m-0 mr-3 mt-2">
                        <label htmlFor="incoTerms" style={{ fontSize: "12px", marginBottom: "3px" }}>
                            Inco Terms
                        </label>
                        <span style={{ color: 'red', marginLeft: '1px' }}>*</span>
                        <Tooltip target=".inco-terms-icon" position="top" content="If send to client option is choosen at the time of seller req, then warehouse and pickup options will be unable to use!" />
                        <i className="pi pi-info-circle inco-terms-icon ml-1"></i>
                    </p>
                    <div className="grid p-2 align-items-center pl-0">
                        {incoTerms.map(eachTerm => {
                            return (
                                <div className={`flex align-items-center mr-3 ml-2 mt-2`} key={`incoTerm-${eachTerm.incoTermId}`}>
                                    <RadioButton className="mt-1" inputId={eachTerm.incoTerm} name="incoTermId" value={eachTerm.incoTermId} onChange={handleIncoTerms} checked={displaySellerPO?.incoTermId === eachTerm.incoTermId} disabled={eachTerm.incoTermId !== 1 && !isWarehouseShipAddr} />
                                    <label htmlFor={eachTerm.incoTerm} className="text-sm ml-2 mt-1">{eachTerm.incoTerm}</label>
                                </div>
                            )
                        })}
                    </div>
                    {
                        (displaySellerPO?.incoTermId) ? (
                            <div className="m-0">
                                <p className="font-semibold text-xs mb-2 mt-1">{displaySellerPO?.incoTermId === 1 ? "Ship Address(Buyer's)" : "Ship Addresses(Procmart's)"}<span style={{ color: 'red', marginLeft: '1px' }}>*</span></p>
                                {
                                    displaySellerPO?.incoTermId === 1 ?
                                        <ShippingAddressCards shippingAddresses={buyerShipAddrs} selectedAddressId={displaySellerPO?.shipAddrId} handleShippingAddress={handleShippingAddress} /> :
                                        <>
                                            <ShippingAddressCards shippingAddresses={relatedPMShipAddrs} selectedAddressId={displaySellerPO?.shipAddrId} handleShippingAddress={handleShippingAddress} />
                                        </>
                                }
                            </div>
                        ) : null
                    }
                    <div className="hr-line"></div>
                    <div className="mt-1">
                        <p className="font-semibold text-xs">
                            Seller Billing Addresses<span style={{ color: 'red', marginLeft: '1px' }}>*</span>
                            {/*<span >
                                <Button className="p-0 m-0 ml-1" icon="pi pi-refresh" text onClick={() => handleBillAddrsVerify()} size="large" />
                            </span>*/}
                        </p>
                        {
                            sellerBillAddress.length === 0 ?
                                <p className='mb-2 mt-0 ml-2 font-semibold billing-address-msg text-700 text-red-500'>Billing addressses are not available. Please contact tech support</p>
                                :
                                <BillingAddressCards billingAddresses={sellerBillAddress} selectedAddressId={displaySellerPO.billAddrId} handleBillingAddress={handleSellerBillAddrr} />
                        }
                    </div>

                    <div className="flex flex-row justify-content-center">
                        <div className="flex flex-column col-12 mb-2 lg:col-9 lg:mb-0">
                            <TextAreaField labelText="Remarks" name="remarks" value={displaySellerPO.remarks} style={{ minHeight: "100px", width: "100%" }} onChange={handleDisplaySellerPO} />
                        </div>
                        {
                            pmCompanyConfig.isTDSAutomated ?
                            <>
                                <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                                    <label htmlFor="" style={{ fontSize: "12px", marginBottom: "3px" }}>
                                        TDS Section Name
                                        <Tooltip target=".tds-detail" position="top" content="To get this edited, please contact finance team" />
                                        <i className="pi pi-info-circle tds-detail ml-1"></i>
                                    </label>
                                    <TextInputField value={TDSDisplayData.tdsSectionName} disabled />
                                </div>
                                <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                                    <TextInputField labelText="TDS Value" value={TDSDisplayData.tdsValue} disabled />
                                </div>
                            </> : null 
                        }
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }} className="align-items-center">
                        {
                            relatedSellerCompanyDetails.statusId !== 1 && <span className="required-mark">(Creating seller PO is only allowed for fully onboarded companies)</span>
                        }
                        <Button label="Create PO" onClick={handleSubmitSellerPOValidations} permissions={[18]} disabled={relatedSellerCompanyDetails.statusId !== 1} applyThrottle={true} />
                    </div>
                </Panel>
            </div>
        </>
    )
}

export default DisplaySellerPO